import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import BenefitService from "../../services/BenefitService";
import CustomFieldService from "../../services/CustomFieldService";
const initialState = {
  data: {},
  columnConfig: [],
  status: "idle",
  formData: {},
};
export const fetchCustomFields = createAsyncThunk("customField", async () => {
  const response = await CustomFieldService.getCustomFields();
  return response;
});
export const CustomFieldSlice = createSlice({
  name: "customField",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomFields.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCustomFields.fulfilled, (state, action) => {
        state.status = "idle";
        state.data = action.payload;
      });
  },
});

export const selectCustomField = (state) => {
  return state.customField.data;
};

export default CustomFieldSlice.reducer;
